<mat-drawer-container class="example-container mat-typography " autosize>
  <mat-drawer #drawer mode="side" disableClose="true" opened="true">

    <div class="left-menu-logo">
      <img *ngIf="isExpanded" class="menuHamburger" src="../assets/menu-icons/app-logo.svg" alt="menuHamburger">
      <button mat-icon-button (click)="toggle()" class="header-icon" aria-label="Example icon-button with menu icon">
        <mat-icon *ngIf="!isExpanded">menu</mat-icon>
        <img *ngIf="isExpanded" class="menuHamburger" src="../assets/menu-icons/left-menu-icon.svg" alt="expandedLogo">
      </button>
    </div>

    <mat-nav-list>
      <mat-list-item>
        <ng-container *ngIf="!isExpanded">
          <ng-container *ngFor="let mainMenuItem of allMenuList">
            <a mat-list-item class="collapse-menu" *ngIf="mainMenuItem.isVisible">
              <img class="listItemIcon" [src]="mainMenuItem.svgIcon" (click)="toggle()" [title]="mainMenuItem.menu"
                alt="mainMenuItem.menu">
            </a>
          </ng-container>
        </ng-container>
      </mat-list-item>

      <ng-container *ngIf="isExpanded">
        <mat-expansion-panel *ngFor="let mainMenuItem of allMenuList" [expanded]="isRouteExists(mainMenuItem.subRoutes)"
          (click)="mainMenuItem.isDisabled && routeComponent(mainMenuItem.routeComponentName) "
          [disabled]="mainMenuItem.isDisabled" [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header *ngIf="mainMenuItem.isVisible" class="specific-class">
            <img class="listItemIcon" [src]="mainMenuItem.svgIcon" [title]="mainMenuItem.menu" alt="mainMenuItem.menu">
            <span class="listItemName">{{mainMenuItem.menu}}</span>
          </mat-expansion-panel-header>

          <ng-container *ngIf="mainMenuItem.isVisible && mainMenuItem.submenu.length > 0">
            <mat-nav-list *ngFor="let subMenuitem of mainMenuItem.submenu"
              [ngClass]="router.url.includes(subMenuitem.routeComponentName) ? 'menu-active':''">
              <a *ngIf="subMenuitem.isVisible" mat-list-item (click)="routeComponent(subMenuitem.routeComponentName)"
                [routerLink]="[subMenuitem.routeComponentName]">
                <img class="listItemIcon"
                  [src]="router.url.includes(subMenuitem.routeComponentName)?subMenuitem.activeIcon:subMenuitem.icon"
                  [title]="subMenuitem.name" alt="subMenuitem.name">
                <span class="sub-menu-name">{{subMenuitem.name}}</span>
              </a>
            </mat-nav-list>
          </ng-container>
        </mat-expansion-panel>
      </ng-container>
    </mat-nav-list>
  </mat-drawer>

  <div class="example-sidenav-content">
    <app-header></app-header>
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</mat-drawer-container>